import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SortByList from './SortByList';
import { Chip } from '@repo/common';

import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';
import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-bottom.svg';
import MobileSortFilter from './MobileSortFilter';

const MyResumesHeader = ({ sortBy, onSortChange, $isMobile }) => {
  const [isSortOpen, setIsSortOpen] = useState(false);
  const sortAnchorRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sortAnchorRef.current &&
        !sortAnchorRef.current.contains(event.target)
      ) {
        setIsSortOpen(false);
      }
    };

    if (isSortOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSortOpen]);

  return (
    <div className='flex max-w-[1166px] w-full items-start tabletH:pb-[30px] justify-between'>
      {!$isMobile && (
        <div className='typo-h5 text-text-primary'>My Resumes</div>
      )}

      {$isMobile ? (
        <div className='w-full'>
          <MobileSortFilter onChange={onSortChange} filterState={sortBy} />
        </div>
      ) : (
        <div ref={sortAnchorRef} className='relative'>
          <Chip
            icon={isSortOpen ? <ArrowTopIcon /> : <ArrowBottomIcon />}
            iconPosition='after'
            disableTypography={true}
            bgclass='bg-transparent typo-b14 px-4 py-3'
            textclass='text-grayscale-gray07'
            iconclass='text-icon-primary'
            borderclass='ring-0'
            onClick={(e) => {
              e.stopPropagation();
              setIsSortOpen((prev) => !prev);
            }}
          >
            {sortBy}
          </Chip>

          {isSortOpen && (
            <div className='absolute top-[42px] left-0 z-10'>
              <SortByList
                selected={sortBy}
                onSelect={(value) => {
                  onSortChange?.(value);
                  setIsSortOpen(false);
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MyResumesHeader;
